import React from 'react'

import { BookerNavIndicator } from '@/components/booking/booker/nav/booker-nav-indicator'
import { BookerNext } from '@/components/booking/booker/nav/booker-next'
import { BookingStage } from '@/lib/stores/booker-store'

type Props = {
  nextStage: BookingStage | null
}

export const BookerBottomNav = ({ nextStage }: Props) => {
  return (
    <div>
      {nextStage && <BookerNext className="mt-4" stage={nextStage} />}
      <div className="mt-4">
        <BookerNavIndicator />
      </div>
    </div>
  )
}
